import { useNavigate } from "react-router-dom";

export const UserLandingPage = () => {
    const navigate = useNavigate();
    return (
        <div className="hero-banner">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <div className="hero-banner__inner">
                            <h1 className="hero-banner__title">Create work diary</h1>
                            <div className="hero-banner-meta">
                                <p className="loggedin">
                                    To create your work diary, enter your employment details. You'll then be
                                    able to fill in your activities for each day, and generate reports about
                                    your work patterns.
                                </p>
                                <p className="loggedin">
                                    Your data is confidential - it won't be shared with your employer/
                                    practice or any third parties.
                                </p>
                            </div>
                        </div>
                        <br />
                        <div className="float start">
                            <a className="btn btn-primary rounded HomeBtn" href="#" onClick={() => navigate(`/addemployers`)}>
                                Add employment details
                            </a>
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                        <figure className="hero-banner__rotachecker">
                            <img src={require('../../../assets/images/user-landing-page-image-new.jpg')} alt="Test Page" />
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    );
}